import { Component, Input } from '@angular/core';

@Component({
  selector: 'intervention-info',
  template: `
    <div
      class="form-info"
      *ngIf="
        selectedInterventionHistory &&
        (selectedInterventionHistory.createdDate || selectedInterventionHistory.updatedDate)
      "
    >
      <small *ngIf="selectedInterventionHistory.createdDate">
        <span>{{ 'GENERIC.created' | translate }}: </span>
        <span>{{ selectedInterventionHistory.createdDate | momentDate: 'DD-MMMM-YYYY' | translateDateMonth }}</span>
        &nbsp;
      </small>

      <small *ngIf="selectedInterventionHistory.complete === 'TRUE' && selectedInterventionHistory.updatedDate">
        <span>{{ 'GENERIC.completed' | translate }}: </span>
        <span>{{ selectedInterventionHistory.updatedDate | momentDate: 'DD-MMMM-YYYY' | translateDateMonth }}</span>
      </small>
    </div>
  `,
  styles: [
    `
      .form-info {
        background-color: #e0e0e0;
        padding: 5px;
      }
    `,
  ],
})
export class InterventionInfoComponent {
  @Input() selectedInterventionHistory: any;
}
